import "./style.css";
import Navbar from "../../../components/navbar/navbar";
import Footer from "../../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import navBarEn from "../../../translations/en/navbar.json";
import navBarEs from "../../../translations/es/navbar.json";
import pdfTarifaImpo from "../../../assets/pdfs/TARIFARIO_IMPORTACION.pdf";
import pdfTarifaExpo from "../../../assets/pdfs/TARIFARIO_EXPORTACION.pdf";
import pdfTarifaAaacesa from "../../../assets/pdfs/TARIFARIO_AAACESA.pdf";
import pdfTarifaTME from "../../../assets/pdfs/TARIFARIO_TME.pdf";
import Helmet from "react-helmet";
import header from "../../../assets/imgs/bonded-warehouse/header.png";
import banner from "../../../assets/imgs/bonded-warehouse/banner.png";
import plane from "../../../assets/imgs/bonded-warehouse/plane.png";
import slide from "../../../assets/imgs/bonded-warehouse/slide.png";
import { FaPlane } from "react-icons/fa6";
import svg1 from "../../../assets/imgs/bonded-warehouse/01.svg";
import svg2 from "../../../assets/imgs/bonded-warehouse/02.svg";
import svg3 from "../../../assets/imgs/bonded-warehouse/03.svg";
import svg4 from "../../../assets/imgs/bonded-warehouse/04.svg";
import svg5 from "../../../assets/imgs/bonded-warehouse/05.svg";
import svg6 from "../../../assets/imgs/bonded-warehouse/06.svg";
import svg7 from "../../../assets/imgs/bonded-warehouse/07.svg";
import svg8 from "../../../assets/imgs/bonded-warehouse/08.svg";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function BondedWarehouse() {
  const [tStationsBondedWarehouse] = useTranslation("bondedWarehouse");
  const [tSMetaData] = useTranslation("metaData");
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  const showTarifaAaacesa = () => {
    window.open(pdfTarifaAaacesa, "_blank");
  };

  const showTarifaTME = () => {
    window.open(pdfTarifaTME, "_blank");
  };

  const showTarifaImpo = () => {
    window.open(pdfTarifaImpo, "_blank");
  }

  const showTarifaExpo = () => {
    window.open(pdfTarifaExpo, "_blank");
  }

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].stations}/${
      Object.keys(navBarEs["stations-submenu"])[2]
    }`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].stations}/${
      Object.keys(navBarEn["stations-submenu"])[2]
    }`
  );

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content={tSMetaData("estacionesAlmacenFiscalizado.description")}
        />
      </Helmet>
      <Navbar />

      <div className="bond-warehouse-header">
        <div className="bw-img-container">
          <img src={header} alt="Almacenes en México" />
        </div>
        <h1 className="bw-page-title">{tStationsBondedWarehouse("Header.title")}</h1>
      </div>

      <div className="bw-domestic-service">
        <div className="container">
          <div className="title">
            <svg
              width="45"
              height="43"
              viewBox="0 0 54 52"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="icon/colocador">
                <path
                  id="icon/colocador_2"
                  d="M0.606445 52V11.5556L27.0004 0L53.3943 11.5556V52H37.558V28.8889H16.4428V52H0.606445ZM19.0822 52V46.2222H24.361V52H19.0822ZM24.361 43.3333V37.5556H29.6398V43.3333H24.361ZM29.6398 52V46.2222H34.9186V52H29.6398Z"
                  fill="#010c41"
                />
              </g>
            </svg>
            <h4>{tStationsBondedWarehouse("DomesticService.title")}</h4>
          </div>

          <div className="bw-info">
            <p>
              {tStationsBondedWarehouse("DomesticService.info1")}
            </p>
            <p>
              {tStationsBondedWarehouse("DomesticService.info2")} <a href="/estaciones/nacionales" className="redirect-text">{tStationsBondedWarehouse("DomesticService.span")}</a> {tStationsBondedWarehouse("DomesticService.info3")}
            </p>
          </div>
        </div>
      </div>


      <div className="bw-international-air" id="international-service">
        <div className="container">
          <div className="title">
            <div className="plane-icon">
              <FaPlane />
            </div>
            <h4>{tStationsBondedWarehouse("InternationAirport.title")}</h4>
          </div>

          <div className="bw-info">
            <p>
              {tStationsBondedWarehouse("InternationAirport.info1")}
            </p>

            <p>
              {tStationsBondedWarehouse("InternationAirport.info2")}
            </p>
          </div>

          <div className="rates-container">
            <div className="rates-card">
              <h6 className="title">Aeroméxico</h6>
              <p className="subtitle">(CR3)</p>
              <div className="pink-links">
                <button onClick={showTarifaImpo}>{tStationsBondedWarehouse("InternationAirport.checkRatesImpo")}</button>
                <button onClick={showTarifaExpo}>{tStationsBondedWarehouse("InternationAirport.checkRatesExpo")}</button>
              </div>
              <div className="impo-expo-info">
                <div className="impo-info">
                  <div className="title">{tStationsBondedWarehouse("InternationAirport.ArrivalsImport")}</div>
                  <p>CDG</p>
                  <p>AMS</p>
                  <p>ICN</p>
                  <p>LAX</p>
                  <p>LHR</p>
                  <p>MAD</p>
                  <p>IAH</p>
                  <p>MIA</p>
                  <p>ORD</p>
                  <p>YUL</p>
                  <p>YYZ</p>
                </div>
                <div className="expo-info">
                  <div className="title">{tStationsBondedWarehouse("InternationAirport.DeparturesExport")}</div>
                  <p>FCO</p>
                  <p>EZE</p>
                  <p>GRU</p>
                  <p>LHR</p>
                  <p>MAD</p>
                  <p>SCL</p>
                  <p>GUA</p>
                  <p>MDE</p>
                  <p>MIAA</p>
                  <p>SAL</p>
                  <p>SEA</p>
                  <p>YUL</p>
                  <p>YYZ</p>
                </div>
              </div>
            </div>

            <div className="rates-card">
              <h6 className="title">AAACESA</h6>
              <p className="subtitle">(CR4)</p>
              <div className="pink-link">
                <button onClick={showTarifaAaacesa}>{tStationsBondedWarehouse("InternationAirport.checkRates")}</button>
              </div>
              <div className="impo-expo-info">
                <div className="impo-info">
                  <div className="title">{tStationsBondedWarehouse("InternationAirport.ArrivalsImport")}</div>
                  <p>SCL</p>
                  <p>EZE</p>
                  <p>JKF</p>
                  <p>FCO</p>
                  <p>GRU</p>
                  <p>BOG</p>
                  <p>GUA</p>
                  <p>LIM</p>
                  <p>MDE</p>
                  <p>SAL</p>
                  <p>SEA</p>
                  <p>SJO</p>
                </div>
                <div className="expo-info">
                  <div className="title">{tStationsBondedWarehouse("InternationAirport.DeparturesExport")}</div>
                  <p>JFK</p>
                  <p>LAX</p>
                  <p>NRT</p>
                  <p>ICN</p>
                  <p>AMS</p>
                  <p>CDG</p>
                  <p>EWR</p>
                  <p>LIM</p>
                  <p>ORD</p>
                  <p>SFO</p>
                  <p>YVR</p>
                </div>
              </div>
            </div>

            <div className="rates-card">
              <h6 className="title">TME</h6>
              <p className="subtitle">(CR6)</p>
              <div className="pink-link">
                <button onClick={showTarifaTME}>Consulte tarifas</button>
              </div>
              <div className="impo-expo-info">
                <div className="impo-info">
                  <div className="title">{tStationsBondedWarehouse("InternationAirport.ArrivalsImport")}</div>
                  <p>EWR</p>
                  <p>NRT</p>
                  <p>SDQ</p>
                  <p>SFO</p>
                  <p>YVR</p>
                </div>
                <div className="expo-info">
                  <div className="title">{tStationsBondedWarehouse("InternationAirport.DeparturesExport")}</div>
                  <p>IAH</p>
                  <p>BOG</p>
                  <p>SDQ</p>
                  <p>SJO</p>
                  <p> </p>
                </div>
              </div>
            </div>
          </div>
          
          <p className="footer-text">{tStationsBondedWarehouse("InternationAirport.moreInfo")}</p>
        </div>
      </div>

      <div className="bw-banner">
        <div className="image-container">
          <img src={banner} />
        </div>
        <div className="info">
          <div className="title">
            <svg
              width="45"
              height="43"
              viewBox="0 0 53 52"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.7007 0.141812C25.9197 0.0482463 26.1556 0 26.3939 0C26.6323 0 26.8682 0.0482463 27.0872 0.141812L51.0283 10.3662L26.3939 20.8851L1.7596 10.3662L25.7007 0.141812ZM0 13.4307V40.324C0 41.0253 0.422303 41.6564 1.06632 41.9369L24.6343 52V23.9496L0 13.4307ZM28.1535 23.9496L52.7879 13.4307V40.324C52.7882 40.6674 52.6873 41.0032 52.4977 41.29C52.3082 41.5767 52.0383 41.8016 51.7216 41.9369L28.1535 52V23.9496Z"
                fill="white"
              />
            </svg>
            <h6>{tStationsBondedWarehouse("BondedInternational.title")}</h6>
          </div>
          <ul>
            <li>{tStationsBondedWarehouse("BondedInternational.opt1")}</li>
            <li>{tStationsBondedWarehouse("BondedInternational.opt2")}</li>
            <li>{tStationsBondedWarehouse("BondedInternational.opt3")}</li>
            <li>{tStationsBondedWarehouse("BondedInternational.opt4")}</li>
            <li>{tStationsBondedWarehouse("BondedInternational.opt5")}</li>
            <li>{tStationsBondedWarehouse("BondedInternational.opt6")}</li>
            <li>CCTV.</li>
            <li>{tStationsBondedWarehouse("BondedInternational.opt7")}</li>
            <li>{tStationsBondedWarehouse("BondedInternational.opt8")}</li>
          </ul>
        </div>
      </div>

      <div className="special-loads-section">
        <h5>{tStationsBondedWarehouse("HandlingSpecial.title")}</h5>
        <div className="icons-container">

          <div className="item">
            <div className="icon">
              <img src={svg1} />
            </div>
            <p>{tStationsBondedWarehouse("HandlingSpecial.opt1")}</p>
          </div>

          <div className="item">
            <div className="icon">
              <img src={svg2} />
            </div>
            <p>{tStationsBondedWarehouse("HandlingSpecial.opt2")}</p>

          </div>

          <div className="item">
            <div className="icon">
              <img src={svg3} />
            </div>
            <p>{tStationsBondedWarehouse("HandlingSpecial.opt3")}</p>
          </div>

          <div className="item">
            <div className="icon">
              <img src={svg4} />
            </div>
            <p>{tStationsBondedWarehouse("HandlingSpecial.opt4")}</p>
          </div>

          <div className="item">
            <div className="icon">
              <img src={svg5} />
            </div>
            <p>{tStationsBondedWarehouse("HandlingSpecial.opt5")}</p>
          </div>

          <div className="item">
            <div className="icon">
              <img src={svg6} />
            </div>
            <p>{tStationsBondedWarehouse("HandlingSpecial.opt6")}</p>
          </div>

          <div className="item">
            <div className="icon">
              <img src={svg7} />
            </div>
            <p>{tStationsBondedWarehouse("HandlingSpecial.opt7")}</p>
          </div>

          <div className="item">
            <div className="icon">
              <img src={svg8} />
            </div>
            <p>{tStationsBondedWarehouse("HandlingSpecial.opt8")}</p>
          </div>

        </div>
      </div>

      <div className="bw-info-cards">
          <div className="container">
            <div className="custom-card">
              <div className="img-container">
                <img src={plane} />
              </div>
              <div className="bg-title">
                <p>{tStationsBondedWarehouse("ImpoExpoCards.title1")}</p>
                <h4>{tStationsBondedWarehouse("ImpoExpoCards.subtitle")}</h4>
              </div>

              <div className="info-content">
                <h6>{tStationsBondedWarehouse("ImpoExpoCards.title-s1-1")}</h6>
                <ul className="decimal">
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-1.op1")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-1.op2")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-1.op3")}</li>
                </ul>

                <h6>{tStationsBondedWarehouse("ImpoExpoCards.title-s1-2")}</h6>
                <ul className="decimal">
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-2.op1")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-2.op2")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-2.op3")}</li>
                </ul>
              </div>
            </div>


            <div className="custom-card">
              <div className="img-container">
                <img src={slide} />
              </div>
              <div className="bg-title">
                <p>{tStationsBondedWarehouse("ImpoExpoCards.title2")}</p>
                <h4>{tStationsBondedWarehouse("ImpoExpoCards.subtitle")}</h4>
              </div>
              <div className="info-content">
                <p>{tStationsBondedWarehouse("ImpoExpoCards.subtitle-s2")}</p>
                <h6>{tStationsBondedWarehouse("ImpoExpoCards.title-s2-1")}</h6>
                <ul>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-3.op1")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-3.op2")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-3.op3")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-3.op4")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-3.op5")}</li>
                </ul>

                <h6>{tStationsBondedWarehouse("ImpoExpoCards.title-s2-2")}</h6>
                <ul>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-4.op1")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-4.op2")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-4.op3")}</li>
                  <li>{tStationsBondedWarehouse("ImpoExpoCards.opt-4.op4")}</li>
                </ul>
              </div>

              <p className="additional-text">{tStationsBondedWarehouse("ImpoExpoCards.moreInfo")}</p>
            </div>
          </div>
      </div>

      <Footer />
    </>
  );
}

export default BondedWarehouse;
